import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { userRoles } from '../../../environments/environment';
import { PasswordComponent } from '../../shared/profile/password-temp/password.component';
import { ProfileComponent } from '../../shared/profile/profile-temp/profile.component';

@Component({
    selector: 'app-settings',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, PasswordComponent, ProfileComponent],
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent {
    selectedSegment: 'profile' | 'password' = 'profile';
    userRole = localStorage.getItem('userRole');
    userRoles = {
        manage: {
            view: false,
            edit: false
        },
        reset: {
            view: false,
            edit: false
        }
    }

    // Reference to the ProfileComponent
    @ViewChild(ProfileComponent) profileComponent!: ProfileComponent;

    constructor(
        public router: Router
    ) { }

    ngOnInit(): void {
        const user = localStorage.getItem('userRole');
        if (user && user in userRoles) {
            this.userRoles = userRoles[user as keyof typeof userRoles]?.settings
        }
    }

    form = new FormGroup({
        username: new FormControl('')
    });

    get usernameControl(): FormControl {
        return this.form.get('username') as FormControl;
    }

    switchSegment(segment: 'profile' | 'password') {
        this.selectedSegment = segment;
    }

    goBack(): void {
        // console.log("clicked object");
        // this.router.navigate(['/dashboard/user']);
        window.history.back();
    }

    onEditClick(): void {
        if (this.selectedSegment === 'profile' && this.profileComponent) {
            this.profileComponent.enableEdit();
        }
    }
}